import { createFromIconfontCN } from '@ant-design/icons-vue'
import { defineComponent, type PropType } from 'vue'
const BaseIcon = createFromIconfontCN({
  scriptUrl: 'https://cdn2.codesign.qq.com/icons/E9KyaXwRBnb4eZl/latest/iconfont.js' // 在 iconfont.cn 上生成
})

export default defineComponent({
  props: {
    type: {
      type: String as PropType<string>,
      default: ''
    }
  },
  setup(props) {
    return () => <BaseIcon type={props.type} />
  }
})
